export const setCustomArrowsFocus = ()=>{
    const arrows = document.querySelectorAll(".slick-arrow");
    arrows.forEach((item)=>{
        item.className.includes("slick-disabled") ? item.setAttribute("disabled", "true") : item.removeAttribute("disabled");
    });
};
